import type { BadgeProps } from '@/components/ui/badge';

type BadgeVariant = NonNullable<BadgeProps['variant']>;

interface AnalysisTypeMeta {
  labelKey: string;
  variant: BadgeVariant;
}

/**
 * AnalysisHistoryView and VersionHistoryView labelled these from two different
 * key families that resolve to the same Japanese string. This is the surviving
 * one. Only `deep_technical_analysis` is ever written by the backend today; the
 * other entries are kept because the field is a free-form string.
 */
export const ANALYSIS_TYPE_META: Record<string, AnalysisTypeMeta> = {
  deep_technical_analysis: {
    labelKey: 'documents.analysisHistoryView.type.deepTechnicalAnalysis',
    variant: 'info',
  },
  summary: { labelKey: 'documents.analysisHistoryView.type.summary', variant: 'secondary' },
  extraction: { labelKey: 'documents.analysisHistoryView.type.extraction', variant: 'success' },
};

export const ANALYSIS_TYPE_FALLBACK_VARIANT: BadgeVariant = 'warning';
